import React from "react";
import ClaimQuestionViewOnly from "./ClaimQuestionViewOnly";

const ClaimQuizSetViewOnly = ({ setDetail = {}, questions = [] }) => (
  <>
    <div className="sectionpadding bg-white mb-30 claim-form-view-only-panel">
      <p className="claim-form-view-only-title mb-0">
        {setDetail?.setNumberLabel || "Set"}
      </p>
      <hr className="my-3" />
      <div className="claim-form-view-only-field mb-4">
        <p className="claim-form-view-only-label">Title</p>
        <p className="claim-form-view-only-value mb-0">
          {setDetail?.setName || "-"}
        </p>
      </div>
      <div className="claim-form-view-only-field">
        <p className="claim-form-view-only-label">Description</p>
        <p className="claim-form-view-only-value mb-0">
          {setDetail?.setDescription || "-"}
        </p>
      </div>
    </div>

    <ClaimQuestionViewOnly questions={questions} />
  </>
);

export default ClaimQuizSetViewOnly;
